import $ from 'jquery';

export default (container = document) => {
  $('[data-image-gallery]', container).each((i, gallery) => {
    const $gallery = $(gallery);
    let num_slides = 0;
    const gallery_id = `ImageGallery--${i + 1}`;

    if (!$gallery.attr('id')) {
      $gallery.attr('id', gallery_id);
    }

    $gallery.addClass('ImageGallery').addClass('Gallery').addClass('light-arrows').addClass('AnimateOnLoad').addClass('Animate--slide-up');
    $gallery.find('img').each((index, img) => {
      num_slides += 1;
      const $img = $(img);
      const img_src = $img.attr('src');
      const shoppable_items = $img.data('shoppable');
      let shoppable_data = '';

      if (shoppable_items) {
        shoppable_data = `data-shoppable="${shoppable_items}" data-shoppable-img="${img_src}"`;
      }

      $img.replaceWith(`<div class="Gallery__slide" data-slide style="background-image: url('${img_src}');" ${shoppable_data}></div>`);
    });

    if (num_slides < 10) {
      num_slides = `0${num_slides}`;
    }

    $gallery.append(`<div class="Gallery__position"><span data-current-position>01</span> / ${num_slides}</div>`);
  });
};